// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// ---------------------------------------------------------------------------
// Cart-note auto-save
// ---------------------------------------------------------------------------
// Replaces the previous per-keystroke fetch loop (which raced itself and
// caused order-note truncation). Uses document-level event delegation so it
// survives section re-renders (Stiletto's refreshQuickCart replaces the
// drawer HTML on every cart change) and covers both the cart drawer
// (#QuickCartSpecialInstructions) and the cart page (#CartSpecialInstructions).
//
// Three trigger paths:
//   1. `input` (debounced 150ms) — saves while the customer types, with
//      AbortController so only the latest value is ever in flight.
//   2. `change` (blur) — immediate save when focus leaves the textarea.
//   3. `pointerdown` on any express-checkout button container (Apple Pay,
//      Shop Pay, Google Pay, PayPal Express) — these snapshot cart.note
//      server-side at click time and bypass the cart form, so we force a
//      save the moment the customer reaches for one. Capture phase fires
//      before the express button's own handler.
(function () {
  var NOTE_SELECTOR =
    '#QuickCartSpecialInstructions, #CartSpecialInstructions';
  var EXPRESS_SELECTOR =
    '.additional-checkout-buttons, .shopify-payment-button, shop-pay-button';

  var controller = null;
  var debounceTimer = null;
  var lastSavedValue = null;

  function currentNoteInput() {
    return document.querySelector(NOTE_SELECTOR);
  }

  function save(input) {
    var node = input || currentNoteInput();
    if (!node) return;
    if (node.value === lastSavedValue) return;
    lastSavedValue = node.value;
    if (controller) controller.abort();
    controller = new AbortController();
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: node.value }),
      signal: controller.signal,
      keepalive: true,
    }).catch(function (err) {
      if (err.name !== 'AbortError') {
        console.error('Cart note save failed', err);
      }
    });
  }

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches(NOTE_SELECTOR)) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { save(e.target); }, 150);
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches(NOTE_SELECTOR)) return;
    clearTimeout(debounceTimer);
    save(e.target);
  }, true);

  document.addEventListener('pointerdown', function (e) {
    if (!e.target.closest) return;
    var expressBtn = e.target.closest(EXPRESS_SELECTOR);
    if (!expressBtn) return;
    // Scope the textarea lookup to the same form as the express button —
    // the cart page renders BOTH textareas (#CartSpecialInstructions in
    // main-cart, #QuickCartSpecialInstructions in the drawer overlay).
    // A bare `currentNoteInput()` here picks the first in document order,
    // which is the drawer (overlay-group renders before content_for_layout)
    // and still holds the pre-edit cart.note value, clobbering whatever
    // the customer just typed in the visible cart-page textarea.
    var form = expressBtn.closest('form');
    var node = (form && form.querySelector(NOTE_SELECTOR)) || currentNoteInput();
    clearTimeout(debounceTimer);
    save(node);
  }, true);

  // Reset the saved-value cache whenever the cart is refreshed, since the
  // drawer's textarea instance is replaced and its value resets to the
  // server-side cart.note.
  document.addEventListener('quick-cart:updated', function () {
    lastSavedValue = null;
  });
})();